export default __webpack_public_path__ + "static/media/11.d85240a0.png";